import folder from "./folder";
import files from "./files";

export default function* () {
  yield* [...folder,...files];
}
